/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, name: NonNullable<unknown> }} Promos_Raffled_HintInputs */



/**
* | output |
* | --- |
* | "{count}× {name} raffled at this event" |
*
* @param {Promos_Raffled_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_raffled_hint = /** @type {((inputs: Promos_Raffled_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_Raffled_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count}× ${i?.name} tirée(s) au sort lors de cet événement`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count}× ${i?.name} sorteada(s) en este evento`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count}× ${i?.name} sorteada(s) neste evento`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count}× ${i?.name} estratta/e a questo evento`)
	return /** @type {LocalizedString} */ (`${i?.count}× ${i?.name} raffled at this event`)
});